import styled from "styled-components";
import { rgba } from "polished";
import { theme } from "../theme"; // Make sure to import your theme
import { Box } from "./layout";


// Define styles for different sizes
export const InputWrapper = styled(Box)(({
  variant,
  suffix,
  prefix,
  error,
  disabled,
  mainColor,
  errorColor,
  isFocused,
  fullWidth,
  size,
  label,
  labelBold,
  dropdownVisible,
  dropdownUp,
}) => {
  const isOutlined = variant === "outlined" || variant === "standard";
  const borderColor = error ? errorColor : rgba(theme.colors.default.main, 1);
  const hoverColor = error ? errorColor : rgba(mainColor, 0.5);
  // Define styles for different sizes
  const sizeStyles = {
    sm: {
      padding: `0.375rem 0.75rem`,
      paddingInlineStart: suffix && "1.875rem", 
      paddingInlineEnd: prefix && "1.875rem", 
      fontSize: "0.875rem",
      lineHeight: "1.3125rem",
      height:"2.125rem",
      fieldsetTop: variant === "standard" ? ".9375rem" : "-0.5rem",
      fieldsetHeight: variant === "standard" ? "2.6875rem" : `2.5625rem`,
      fieldsetNoLabelHeight: "2.0625rem",
      LableTop: variant === "standard" ? "-0.9357rem" : "1.03125rem",
      iconSize: "1.25rem",
      suffixTop: label
        ? variant === "standard"
          ? "2.53125rem"
          : "1.03125rem"
        : "1.03125rem",
    },
    md: {
      padding: "0.5rem 1rem",
      lineHeight: "1.5rem",
      paddingInlineStart: suffix && "2.25rem", 
      paddingInlineEnd: prefix && "2.25rem", 
      fontSize: "0.875rem",
      height:"2.5rem",
      fieldsetTop: variant === "standard" ? "1rem" : "-0.5rem",
      fieldsetHeight: variant === "standard" ? "3.25rem" : "3rem",
      fieldsetNoLabelHeight: "2.5rem",
      LableTop: variant === "standard" ? "-0.9357rem" : "1.25rem",
      iconSize: "1.25rem",
      suffixTop: label
        ? variant === "standard"
          ? "3rem"
          : "1.25rem"
        : "1.25rem",
    },
    lg: {
      padding: "0.6875rem 1.25rem",
      paddingInlineStart: suffix && "2.5rem", 
      paddingInlineEnd: prefix && "2.5rem", 
      fontSize: "1.25rem",
      lineHeight: "1.875rem",
      height:"3.25rem",
      fieldsetTop: variant === "standard" ? "1.25rem" : "-0.5rem",
      fieldsetHeight: variant === "standard" ? "4.125rem" : "3.75rem",
      fieldsetNoLabelHeight: "3.625rem",
      LableTop: variant === "standard" ? "-0.9357rem" : "1.625rem",
      iconSize: "1.875rem",
      suffixTop: label
        ? variant === "standard"
          ? "3.75rem"
          : "1.625rem"
        : "1.625rem",
    },
  };

  return {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    gap: "0.25rem",
    width: "100%",
    maxWidth: fullWidth ? "100%" : "15rem",
    "& .valueWrapper":{
      alignItems:"center",

    },
    "& input, .valueBox": {
      width: "100%",
      padding: sizeStyles[size].padding, // Apply size-based padding
      paddingInlineStart: sizeStyles[size].paddingInlineStart, // Apply size-based paddingInlineStart
      paddingInlineEnd: sizeStyles[size].paddingInlineEnd, // Apply size-based paddingInlineStart
      fontSize: sizeStyles[size].fontSize,
      lineHeight: sizeStyles[size].lineHeight,
      height: sizeStyles[size].height,
      borderRadius: isOutlined ? theme.radius.element : "0",
      border: "none",
      backgroundColor: disabled
        ? "#f5f5f5"
        : variant === "filled"
          ? rgba(mainColor, 0.1)
          : theme.colors.light.light,
      color: error ? errorColor : theme.colors.default.dark,
      transition: "border-color 0.3s, background-color 0.3s",
      boxShadow:
        variant === "filled" ? `0 1px 2px ${rgba(mainColor, 0.2)}` : "none",
      outline: "none",
      order: variant === "standard" ? "1" : "0",
      textOverflow:"ellipsis",
      whiteSpace:"nowrap",
      overflow:"hidden",
      "&:hover": {
        "& ~ fieldset:not(.focused)": {
          borderColor: !disabled && hoverColor,
        },
      },

      "&:focus": {
        boxShadow:
          variant === "filled" ? `0 0 0 2px ${rgba(mainColor, 0.2)}` : "none",
      },

      "&:disabled": {
        cursor: "not-allowed",
        backgroundColor: theme.colors.light.main,
        color:theme.colors.default.dark,
      },
    },

    label: {
      position: variant === "standard" ? "static" : "absolute",
      left:
        variant === "standard"
          ? "0"
          : suffix
            ? `calc(${sizeStyles[size].paddingInlineStart} - 0.5rem)`
            : "0.625rem",
      top: sizeStyles[size].LableTop,
      transform: variant === "standard" ? "translateY(0)" : "translateY(-50%)",
      color: error ? errorColor : rgba(theme.colors.default.dark, 0.75),
      fontSize: sizeStyles[size].fontSize, // Dynamic font size
      fontWeight: labelBold && 600,
      paddingInline: variant !== "standard" && "0.5rem",
      pointerEvents: "none",
      transition: "all 0.2s ease",
      textTransform: "capitalize",
      order: variant === "standard" ? "0" : "1",

      "&.focused": {
        top: variant === "standard" ? "-0.9357rem" : "0",
        fontSize:
          variant === "standard" ? sizeStyles[size].fontSize : "0.75rem",
        color: error ? errorColor : rgba(mainColor, 0.5),
      },

      "&.error": {
        color: errorColor,
      },
      "& .required": {
        color: theme.colors.danger.main,
        display: "inline-block",
      },
      "&.disabled": {
        color: "#9e9e9e",
      },
    },

    fieldset: {
      width: "100%",
      height: sizeStyles[size].fieldsetHeight, // Apply dynamic height based on size
      fontSize: variant === "standard" ? sizeStyles[size].fontSize : "0.75rem",
      position: "absolute",
      left: 0,
      top: sizeStyles[size].fieldsetTop,
      margin: 0,
      padding: "0 0.625rem",
      paddingInlineStart: `calc(${sizeStyles[size].paddingInlineStart} - 0.5rem)`, // Apply size-based paddingInlineStart
      pointerEvents: "none",
      outline: "none",
      border: isOutlined ? `0.0625rem solid ${borderColor}` : "none",
      borderRadius: isOutlined ? theme.radius.element : "0",
      color: isFocused || error ? mainColor : theme.colors.default.dark,
      transition: "all 0.2s ease",
      order: variant === "standard" ? "1" : "0",
      textOverflow:"ellipsis",
      "&.noLabel": {
        top: 0,
        height: sizeStyles[size].fieldsetNoLabelHeight,
      },
      "& legend": {
        paddingInline: 0,
        opacity: 0,
        maxWidth: 0,
        overflow: "hidden",
        fontWeight: labelBold && 600,
        "& span": {
          paddingInline: "0.5rem",
          display: "inline-flex",
          whiteSpace: "nowrap",
        },
      },

      // Change styles when focused
      "&.focused": {
        color: mainColor,
        borderColor: error ? errorColor : rgba(mainColor, 0.5),
        "& legend": {
          maxWidth: variant === "standard" ? 0 : "100%",
        },
      },

      // Error state
      "&.error": {
        color: errorColor,
      },
    },

    ".helperText": {
      fontSize: "0.75rem",
      color: error ? errorColor : "#666",
      marginTop: "0.25rem",
      alignItems:"center",
      display:"inline-flex",
      order: variant === "standard" ? "1" : "0",
      "& svg":{
        width:"1.25rem",
        height:"1.25rem",
      },
    },

    ".placeholder": {
      position: "absolute",
      left: "0.75rem",
      top: "1.5rem",
      color: "#aaa",
      pointerEvents: "none",
      transition: "all 0.2s ease",
      opacity: isFocused ? 0 : 1, // Make placeholder invisible on focus
    },

    ".suffix,.prefix,.close": {
      width: sizeStyles[size].iconSize,
      height: sizeStyles[size].iconSize,
      fontSize: sizeStyles[size].fontSize,
      transform: "translateY(-50%)",
      top: sizeStyles[size].suffixTop,
      position: "absolute",
      textTransform: "uppercase",
      color:  disabled ? borderColor : hoverColor,
      // pointerEvents:"none",
    },
    ".suffix": {
      left: "0.625rem",
    },
    ".prefix": {
      right: "0.625rem",
    },
    ".close": {
      right: "1.875rem",
      pointerEvents:"auto",
    },
    ".dropdown": {
      listStyle: "none",
      margin: 0,
      padding: "0.5rem 0",
      position: "absolute",
      top: dropdownUp ? "auto" : "100%", // Open above or below
      bottom: dropdownUp ? "100%" : "auto", // Open above or below
      left: 0,
      width: "100%",
      backgroundColor: theme.colors.light.main, // Adjust dropdown background color
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", // Subtle shadow for depth
      borderRadius: theme.radius.element,
      zIndex: 10,
      maxHeight: "200px", // Max height to avoid large lists
      overflowY: "auto", // Scroll for large lists
      transition: "opacity 0.3s ease-in-out, transform 0.3s ease-in-out",
      opacity: dropdownVisible ? 1 : 0, // Smooth dropdown appearance
      transform: dropdownVisible ? "scaleY(1)" : "scaleY(0)", // Dropdown scaling effect
      transformOrigin: dropdownUp ? "bottom" : "top", // Scale from the correct direction
      pointerEvents: dropdownVisible ? "auto" : "none", // Disable pointer events when closed
    },

    ".dropdownItem, .no-options": {
      padding: sizeStyles[size].padding,
      cursor: "pointer",
      fontSize: sizeStyles[size].fontSize,
      color: theme.colors.default.dark,
      backgroundColor: "transparent",
      transition: "background-color 0.2s ease, color 0.2s ease",
      position: "relative",
      overflow: "hidden",
      
      "&:hover,&.highlighted": {
        backgroundColor: rgba(mainColor, 0.15), // Change background on hover
        color: theme.colors.primary.main, // Change text color on hover
      },
      "&.disabled": {
        opacity:0.4,
        cursor:"not-allowed",
        "&:hover": {
          backgroundColor: "transparent", // Change background on hover
          color:  theme.colors.default.dark, // Change text color on hover
        },
      },
      "&.selected": {
        backgroundColor: rgba(mainColor, 0.5),
        borderBlockEnd: `solid 0.0625rem ${rgba(mainColor, 0.1)} `,
        color: theme.colors.light.main,
      },
    },
  };
});

